/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react';
import { ModelManager } from '@adobe/aem-spa-page-model-manager';
import '@glidejs/glide/src/assets/sass/glide.core.scss';
import '@glidejs/glide/src/assets/sass/glide.theme.scss';

import '../styles/cobrand.scss';
import rtlPlugin from 'stylis-plugin-rtl';
import { StyleSheetManager } from 'styled-components';

import { defineComponentMapping } from '../import-components';
import path from 'path';
import {
  canUseDOM,
  CustomModelClient,
  getEnvProp,
  populatePIdataLayer,
  respGridUtil,
  UserSessionProvider,
  RENDERER,
  DynamicDCAPageProvider,
} from '@marriott/mi-headless-utils';
import {
  useDCAPageModelStore,
  useClientEnvVarsStore,
  PageModelStoreType,
  PageModelState,
  createPageModelStore,
  PageModelContext,
} from '@marriott/mi-store-utils';
path.resolve('./next.config.js');
import { envVarKeys } from '../_constants/envVarKeys';
import { RESOLVED_URL } from '@marriott/mi-cobrand-components';
import { Types } from '@marriott/mi-ui-library';
import { version as globalStylesVersion } from '@marriott/global-styles/package.json';

declare global {
  interface Window {
    jQuery: unknown;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    $: any;
    deployedEnvType: string;
    dataLayer?: Record<string, unknown>;
    targetGlobalSettings: Record<string, unknown>;
  }
}

if (canUseDOM) window.$ = window.jQuery = require('jquery-slim/dist/jquery.slim.min.js');

const modelClient = new CustomModelClient(process.env.NEXT_PUBLIC_AEM_HOST);

if (process.env.NODE_ENV !== 'test') {
  ModelManager.initializeAsync({
    modelClient,
  });
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const App = (props: any) => {
  const { Component, pageProps } = props;
  const {
    model,
    isAuthorMode,
    resourceUrl,
    query,
    NEXT_PUBLIC_FETCH_OFFERS_API_URL,
    showError,
    apolloEnvVars,
    resolvedUrl,
    currentLocale,
    TARGET_PROPERTY_TOKEN,
    NEXT_GLOBAL_ASSET_PREFIX,
  } = pageProps;
  const allowedComponents = model?.cqItems?.root?.[':items']?.responsivegrid?.allowedComponents?.components;
  const isStickyCardEnabled = model?.enableStickyHeader && model?.enableStickyHeader === 'true' ? true : false;
  const isCardComparisonFeatureEnabled =
    model?.enableCardComparisonFeature && model?.enableCardComparisonFeature === 'true';
  const isComparisonTrayEnabled = model?.enableComparisonTray && model?.enableComparisonTray === 'true';
  const dataLayer = pageProps?.dataLayer;
  if (model?.seo && model?.seo.uri) {
    const allUri = model?.seo.uri;
    const langList = Object.keys(allUri);
    model['hreflangList'] = langList?.map(key => ({
      href: allUri[key],
      hreflang: key,
    }));
  }
  const respGridModel = respGridUtil(model?.cqItems?.root?.[':items']?.responsivegrid, { normalizeTracking: true });
  const respGridModelClone = JSON.parse(JSON.stringify(respGridModel)); //To deep clone the model
  const store = useRef<PageModelStoreType>();
  const initialPageModel: PageModelState = {
    pageModel: respGridModel,
  };
  const isChasePage = resolvedUrl?.includes(RESOLVED_URL?.CHASECREDITCARDURL);
  const isAmexPage = resolvedUrl?.includes(RESOLVED_URL?.AMEXCREDITCARDURL);
  const isRtl = currentLocale === 'ar-AE';

  if (!store.current) {
    store.current = createPageModelStore(initialPageModel);
  }

  const setPageModel = useDCAPageModelStore(state => state.setPageModel);
  if (setPageModel) {
    setPageModel(respGridModelClone);
  }
  const rtlPluginTs = (...args: unknown[]) => {
    return rtlPlugin(args[0] as number, args[1] as string);
  };

  const envVars = apolloEnvVars ? apolloEnvVars : {};
  envVars['NEXT_PUBLIC_FETCH_OFFERS_API_URL'] = NEXT_PUBLIC_FETCH_OFFERS_API_URL;
  envVars['NEXT_PUBLIC_ENABLE_WEBSDK'] =
    getEnvProp(envVarKeys.NEXT_PUBLIC_ENABLE_WEBSDK) === 'true' && model?.enableWebSDK === 'true';
  envVars['ENABLE_ACDL'] = model?.['ENABLE_ACDL'];
  envVars['ENABLE_ECM'] = model?.['ENABLE_ECM'];
  const setEnvVars = useClientEnvVarsStore(state => state.setEnvVars);
  envVars['NEXT_PUBLIC_ENABLE_DCA_V2'] = getEnvProp(envVarKeys.NEXT_PUBLIC_ENABLE_DCA_V2);
  envVars['TARGET_PROPERTY_TOKEN'] = TARGET_PROPERTY_TOKEN;
  useEffect(() => {
    const assetUrl = `https://www.marriott.com/mi-assets/mi-global/`;
    const globalStyle = document.createElement('link');

    globalStyle.rel = 'stylesheet';
    globalStyle.href =
      assetUrl +
      (model?.rtlEnable == 'true'
        ? `global-styles/${globalStylesVersion}/marriot.global.rtl.css`
        : `global-styles/${globalStylesVersion}/marriot.global.css`);
    document.head.appendChild(globalStyle);
  }, []);
  useEffect(() => {
    if (model?.templateName === 'headless-next-js-cdp-template') {
      window.targetGlobalSettings = {
        aepSandboxId: '4b4e08f2-8e19-4baf-8e08-f28e19fbafe2',
        aepSandboxName: 'aepdevelopment',
      };
    }
  }, [model]);

  if (setEnvVars) {
    setEnvVars(envVars);
  }

  if (canUseDOM) {
    populatePIdataLayer();
  }

  defineComponentMapping(
    allowedComponents,
    resourceUrl,
    isAuthorMode,
    dataLayer,
    {
      isStickyCardEnabled,
      allQueryParams: query,
      isCardComparisonFeatureEnabled,
      isComparisonTrayEnabled,
    },
    showError,
    resolvedUrl,
    {
      isTextCentered: isChasePage,
      featureTitleFontSize: isChasePage ? Types.size.large : Types.size.extraLarge,
      isTickIconFilled: isChasePage,
    },
    {
      isChaseButton: isChasePage,
      isAmexButton: isAmexPage,
      isTertiaryLinksVisible: isAmexPage,
      isImagehidden: isAmexPage,
      isPointDescriptionVisible: isAmexPage,
      isBonusPointsLabelVisible: isAmexPage,
      isAnnualFeeVisible: isAmexPage,
    },
    isRtl
  );
  Object.defineProperty(rtlPluginTs, 'name', { value: 'rtlPluginMonorepo' });
  return (
    // For ACDL setup - @see https://marriottcloud.atlassian.net/browse/DXP-16772
    <UserSessionProvider pageProps={pageProps} includePiData={true} renderer={RENDERER.COBRAND}>
      <PageModelContext.Provider value={store.current}>
        <StyleSheetManager stylisPlugins={pageProps?.model?.rtlEnable == 'true' ? [rtlPluginTs] : []}>
          <DynamicDCAPageProvider Component={Component} pageProps={pageProps} />
        </StyleSheetManager>
      </PageModelContext.Provider>
    </UserSessionProvider>
  );
};

export default App;
